<template>
    <NuxtLink
        v-if="parts[0]"
        :to="`${THUMBNAIL_BASE_URL}/PDF/${parts[0]?.knihaKod}.P.${parts[0]?.prilohaKod}.pdf`"
        target="_blank"
    >
        <span
            class="whitespace-nowrap"
            v-html="stringStart"
        />
    </NuxtLink>
</template>

<script lang="ts" setup>
const props = defineProps<{
    html: string
}>()
const route = useRoute()

const THUMBNAIL_BASE_URL =
    "https://app.iprpraha.cz/apl/mnt/App_UAP/portal/images/figury"

const formattedHtml = props.html
    .replace(/&nbsp;/g, " ")
    .replace(/<span class="uapz09">(.*?)<\/span>/g, "$1")

const stringStart = formattedHtml
    .split(/ \d/)[0]
    ?.replaceAll(" ", "&nbsp;")
    .replaceAll("", "<i class='pi pi-arrow-right text-sm'></i>")
    .replace("🡪", "<i class='pi pi-arrow-right text-sm'></i>")

const kod = formattedHtml.match(/\d\.?( ?(\/|,) ?)?/g)?.join("")
type Codes = {
    knihaKod: string
    prilohaKod: string
    origin: string
}
const parts = ref<Codes[]>([])
const codes = kod?.split(/ ?(\/|,) ?/g)
codes?.forEach(code => {
    if (code === "/") return
    const prilohaKod =
        code.split(".").length === 5
            ? code?.split(".").slice(1).join(".")
            : code
    const knihaKod =
        code.split(".").length === 5
            ? (code.split(".")[0] as string)
            : ((route.params.kody as string[])[0] as string)
    parts.value.push({ origin: code, knihaKod, prilohaKod })
})
</script>

<style scoped></style>
